import Player from "./player/player";

const App = () => {
  const rootDiv = document.getElementById("data-for-embedded-player");
  const contentUrl = rootDiv?.getAttribute("data-for-embedded-player") || "";

  return <Player contentUrl={contentUrl} />;
};

export default App;
